var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Box, CircularProgress } from '@mui/material';
import React, { useContext, useState } from 'react';
import { dismissSyncStatus, getSyncStatus } from '../rest/BackendApi';
import { useRecursiveTimeout } from '../hooks/useInterval';
import { getExponentialBackoffDelay } from '../util/DelayUtil';
import UserContext from '../UserContext';
function OrgSyncStatusDisplay(props) {
    const { syncReadyCallback } = props;
    const userContext = useContext(UserContext);
    const [inProgress, setInProgress] = useState(false);
    const [syncStatus, setSyncStatus] = useState(null);
    const [delay, setDelay] = useState(500);
    const [attempt, setAttempt] = useState(1);
    const maxAttempts = 30;
    const getNonSuccessSyncStatusBox = (syncStatus) => {
        function dismiss(id) {
            return __awaiter(this, void 0, void 0, function* () {
                yield dismissSyncStatus(id);
                setSyncStatus(null);
            });
        }
        return (_jsx(Alert, { severity: getSyncStatusSeverity(syncStatus.result), onClose: () => dismiss(syncStatus.id), children: syncStatus.message }));
    };
    useRecursiveTimeout(() => __awaiter(this, void 0, void 0, function* () {
        const loadSyncStatus = () => __awaiter(this, void 0, void 0, function* () {
            let syncStatus = yield getSyncStatus('Org');
            console.log('syncStatus', syncStatus);
            if ((syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.result) === 'InProgress') {
                if (attempt >= maxAttempts) {
                    setInProgress(false);
                    setDelay(null);
                }
                else {
                    setInProgress(true);
                    setAttempt(attempt + 1);
                    setDelay(getExponentialBackoffDelay(attempt, 500));
                }
            }
            else {
                if (syncStatus != null && userContext.refreshUser) {
                    console.log('refreshing user');
                    userContext.refreshUser();
                }
                setInProgress(false);
                setDelay(null);
                setSyncStatus(syncStatus);
                console.log('updated status');
                syncReadyCallback(syncStatus, attempt);
            }
        });
        yield loadSyncStatus();
    }), delay);
    if (inProgress) {
        return (_jsx(Box, { paddingBottom: "10px", children: _jsx(Alert, { severity: "info", sx: { '.MuiAlert-message': { width: '100%', overflow: 'hidden' } }, children: _jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx("span", { children: "Organisation(s) syncing with Xero in progress" }), _jsx("span", { children: _jsx(CircularProgress, { size: "18px", color: "info" }) })] }) }) }));
    }
    else if (syncStatus && (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.result) != 'Success') {
        return _jsx(Box, { paddingBottom: "10px", children: getNonSuccessSyncStatusBox(syncStatus) });
    }
}
const getSyncStatusSeverity = (syncResult) => {
    switch (syncResult) {
        case 'Error':
            return 'error';
        case 'Partial':
            return 'warning';
        case 'LimitReached':
            return 'warning';
        default:
            return 'info';
    }
};
export default React.memo(OrgSyncStatusDisplay);
